import React from 'react';
import {
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Button,
    FormGroup,
    Label,
    Input
} from 'reactstrap';

import Dropzone from 'react-dropzone';

const defaultMsg = "Arrastra o selecciona un archivo";

export default class SaleSupportForm extends React.Component {

    constructor(props) {
        super(props);
        this.onDrop = this._onDrop.bind(this);
        this.onDragEnter = this._onDragEnter.bind(this);
        this.onDragLeave = this._onDragLeave.bind(this);
        this.uploadMessage = this._uploadMessage.bind(this);
        this.submit = this._submit.bind(this);
        
        this.state = {
            title : '',
            file : {
                name : '',
                file : null,
            },
            cover : {
                name : '',
                file : null,
            }
        }
    }

    componentWillReceiveProps(props) {
        if(props.item && (!this.props.item || props.item.id !== this.props.item.id)) {
            this.setState({
                title : props.item.title,
                file : {
                    name : props.item.file_name,
                    file : null
                },
                cover : {
                    name : props.item.cover_file_name,
                    file : null
                }
            });
        } else if( ! props.item) {
            this.state = {
                title : '',
                file : {
                    name : '',
                    file : null,
                },
                cover : {
                    name : '',
                    file : null,
                }
            }
        }
    }

    _uploadMessage(dzName) {
        const dropzone = this.refs[dzName];
        let message = defaultMsg;
            
        try {
            const dropState = dropzone.state;
            if(dropState.isDragActive) {
                message = "Suelta tu archivo aquí";
            }else if(dropState.isDragReject) {
                message = "Por favor, solo selecciona archivos XLSX";
            }
        }catch(e) {}

        return message;
    }

    _onDrop(dzName, accepted, rejected) {
        if(accepted.length === 1 && rejected.length === 0) {
            const file = accepted[0];
            this.setState({
                [dzName === 'coverDropzone' ? 'cover' : 'file'] : {
                    name : file.name,
                    file : file,
                }
            })
        }else if(accepted.length > 0) {
            this.showError("Por favor, selecciona únicamente un archivo");
        }
        let message = defaultMsg;
        this.setState({
            dropMessage : message
        });
        
    }

    _onDragEnter(dzName, evt) {
        let message = this.uploadMessage(dzName);
        this.setState({
            dropMessage : message
        });
    }

    _onDragLeave(dzName, vt) {
        this.setState({
            dropMessage : 'ASDASD'
        });
    }

    _submit() {
        const data = {
            item : this.props.item || null,
            title : this.state.title,
            cover : this.state.cover.file,
            file : this.state.file.file,
        };
        this.props.store(data);
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.hide}>
                <ModalHeader>
                    Formulario
                </ModalHeader>
                
                <ModalBody>
                    <div>
                        <FormGroup>
                            <Label for="titleInput">
                                Título
                            </Label>
                            <Input type="text" maxLength={50} id="titleInput" value={this.state.title} onChange={(event) => this.setState({title : event.target.value})}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Portada</Label>
                            <Dropzone
                            ref="coverDropzone"
                            className="dropzone"
                            activeClassName="active"
                            rejectClassName="reject"
                            accept={"image/*"}
                            onDrop={(accepted, rejected) => this.onDrop('coverDropzone', accepted, rejected)}
                            onDragEnter={(evt) => this.onDragEnter('coverDropzone', evt)}
                            onDragLeave={(evt) => this.onDragLeave('coverDropzone', evt)}>
                                {
                                    this.state.cover.name ? this.state.cover.name : 'Arrastra o selecciona una portada'
                                }
                            </Dropzone>
                        </FormGroup>
                        <FormGroup>
                            <Label>Archivo (mp4 o pdf)</Label>
                            <Dropzone
                            ref="fileDropzone"
                            className="dropzone"
                            activeClassName="active"
                            rejectClassName="reject"
                            accept={".mp4,.pdf"}
                            onDrop={(accepted, rejected) => this.onDrop('fileDropzone', accepted, rejected)}
                            onDragEnter={(evt) => this.onDragEnter('fileDropzone', evt)}
                            onDragLeave={(evt) => this.onDragLeave('fileDropzone', evt)}>
                                {
                                    this.state.file.name ? this.state.file.name : 'Archivo'
                                }
                            </Dropzone>
                        </FormGroup>
                        
                    </div>
                </ModalBody>

                <ModalFooter>
                    
                    {
                        this.props.posting ?
                            <div className="progress w-100">
                                <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow={this.props.progress} aria-valuemin={0} aria-valuemax={100} style={{width: this.props.progress + '%'}}></div>
                            </div>
                        :
                            <div>
                                <Button color="secondary" onClick={this.props.hide}>Cancelar</Button>
                                <Button color="primary" onClick={this.submit}>Guardar</Button>
                            </div>
                    }
                    
                </ModalFooter>
            </Modal>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/support/SaleSupportForm.jsx
 **/